<template>
  <div>
    <hr aria-hidden="true" />
  </div>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-content-divider",
}
</script>

<style scoped>
hr {
  border: 0;
  height: 0;
  display: block;
  border-bottom: 1px solid var(--crf-border)
}
</style>
